import React from "react";
import { SectionHeader } from "./Rates";
import { PRODUCTS } from "../mock";

const Coin = ({ metal, weight }) => {
  const gold = metal === "gold";
  return (
    <div className="relative flex items-center justify-center py-8">
      <div
        className="coin-shine relative h-36 w-36 rounded-full flex flex-col items-center justify-center overflow-hidden"
        style={{
          background: gold
            ? "radial-gradient(circle at 35% 30%, #f6e29a, #d4af37 55%, #a97c1e)"
            : "radial-gradient(circle at 35% 30%, #f2f4f7, #c8ccd2 55%, #8b9099)",
          boxShadow: gold
            ? "0 12px 30px -8px rgba(212,175,55,0.5), inset 0 0 0 4px rgba(255,255,255,0.25), inset 0 0 0 8px rgba(150,110,20,0.35)"
            : "0 12px 30px -8px rgba(160,170,180,0.4), inset 0 0 0 4px rgba(255,255,255,0.4), inset 0 0 0 8px rgba(120,125,135,0.35)",
        }}
      >
        <span className="font-display smallcaps text-lg tracking-[0.15em] leading-none" style={{ color: gold ? "#6b4e10" : "#4a4f57" }}>Twin</span>
        <span className="font-display smallcaps text-lg tracking-[0.15em] leading-none" style={{ color: gold ? "#6b4e10" : "#4a4f57" }}>Brain</span>
        <span className="font-display text-2xl mt-1" style={{ color: gold ? "#4a360a" : "#3a3f47" }}>{weight}</span>
      </div>
    </div>
  );
};

const Products = () => {
  return (
    <section id="coins" className="relative py-24 bg-[#0b0f19]">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        <SectionHeader eyebrow="Our Products" title="TwinBrain Branded Coins" sub="Every coin carries the TwinBrain name — a mark of purity, trust and lasting craftsmanship." />

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {PRODUCTS.map((p, i) => (
            <div key={i} className="border border-white/8 bg-white/[0.02] card-glow overflow-hidden">
              <div className="bg-gradient-to-b from-white/[0.03] to-transparent border-b border-white/5">
                <Coin metal={p.metal} weight={p.weight} />
              </div>
              <div className="p-6">
                <h3 className="font-display text-2xl text-white">{p.name}</h3>
                <p className="font-body text-gray-400 text-sm mt-2 leading-relaxed">{p.desc}</p>
                <div className="flex items-end justify-between mt-5">
                  <div>
                    <p className="font-ui text-[9px] tracking-[0.2em] uppercase text-muted-foreground">Today's price</p>
                    <p className="font-display text-2xl text-gold">{p.price}</p>
                  </div>
                  <span className={`font-ui text-[9px] tracking-wider uppercase px-3 py-1.5 ${p.metal === 'gold' ? 'bg-gold/10 text-gold' : 'bg-white/8 text-gray-300'}`}>{p.tag}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
